import React, { Component } from 'react'
import Select from 'react-select'

class LoginType extends Component {
    constructor() {
        super()
        this.state = {
            LoginTypeList:[ {"label":"Email","value":"Email"},{"label":"Primary Mobile No","value":"Mobile"}]
        }
        this.isComponentStillMounted = true
    }

   

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    

    render() {
       return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={this.state.LoginTypeList}
                placeholder="Select Login Type"
                onChange={(e) => { (e) ? this.props.loginTypeChange(e) : this.props.loginTypeChange([])}}
                />
            </div>
        )
    }
}

export default LoginType


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/DropDowns/LoginType.js